
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.798 15.3c4.237 0 7.71 3.162 7.701 7.7H4.1c-.009-4.536 3.463-7.7 7.7-7.7z","fill":"#FF7009"}}),_c('path',{attrs:{"d":"M18.15 4.572c-.971 0-1.664.425-2.305 1.343l-1.842 2.652V1H9.599v7.57L7.755 5.918c-.64-.915-1.333-1.343-2.305-1.343-1.468 0-2.444 1.083-2.45 2.419 0 1.142.535 1.887 1.67 2.613l7.132 4.594 7.128-4.591c1.135-.732 1.674-1.477 1.67-2.614-.004-1.34-.98-2.423-2.45-2.423z","fill":"#0AAD0A"}})])
          )
        }
      }
    